import React, { ReactElement } from 'react';

import { ChangeEvent } from '@philips-emr/tws-core/lib/component/types';

import { Input } from '../..';

interface Props {
  calendar: ReactElement | null;
  date: string;
  enabled: boolean;
  onChange: (event: ChangeEvent<string | string[]>) => void;
  placeholder?: string;
  readOnly: boolean;
  valid: boolean;
}

function DateFieldBasic(props: Props): ReactElement {
  const { calendar, date, enabled, onChange, placeholder, readOnly, valid } = props;

  const formatters = {
    value: { name: 'date' },
  };

  return (
    <div className="c-date-field--basic">
      <div className="c-date-field__container c-date-field__input">
        <Input enabled={enabled} externalAction={calendar} formatters={formatters} onChange={onChange} placeholder={placeholder} readOnly={readOnly} valid={valid} value={date} />
      </div>
    </div>
  );
}

export default DateFieldBasic;
